function Api() {
  return <div>API</div>;
}

export default Api;
